const currencyRenderer = (amount) => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
  });
  return `₦${formatter.format(amount)}`;
}

export default currencyRenderer;